import { Spreadsheet } from '@syncfusion/ej2-spreadsheet';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Toolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { App } from '../../App';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { AddOrUpdateDocumentationTopicManager } from '../../Exporters/ManagersExporter';

export class DocumentationManager {

    constructor(private containerElement: JQuery) { }
    
    private addOrUpdateDocumentationTopicModalHelper : ModalHelper;
    private addOrUpdateDocumentationTopicManager : AddOrUpdateDocumentationTopicManager;

    private documentationGrid : Grid;


    public initialize() {
        var self = this;

        this.addOrUpdateDocumentationTopicModalHelper = new ModalHelper();
        this.addOrUpdateDocumentationTopicModalHelper.createModal("add-or-update-documentation-popup", true);

        Grid.Inject(Page, Sort, Toolbar);

        self.initializeDocumentationTopics();
    }

    private initializeDocumentationTopics() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var uploadedWorkbooksContainer = self.containerElement.find('#admin-documentation-topics-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;


        let data: DataManager = new DataManager({
            url: '/api/information/documentationtopics',
            adaptor: new WebApiAdaptor
        });

        self.documentationGrid = new Grid(
            {
                height: '100%',
                toolbarTemplate: '#toolbar-template',
                dataSource: data,
                columns: [
                    { field: 'Topic', headerText: 'Topic'},
                    { field: 'TopicIndex', headerText: 'Topic index', width: 150},
                    { field: 'SubTopic', headerText: 'Sub topic'},
                    { field: 'SubTopicIndex', headerText: 'sub topic index', width: 150 },
                ],
                allowSorting: false,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                pageSettings: { pageSize: 2000 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                    loadingContainer.addClass('d-none');
                    uploadedWorkbooksContainer.removeClass('d-none');
                },
                recordDoubleClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var documentationId = args.rowData["Id"];
                        if(documentationId != undefined) {
                            self.addOrUpdateDocumentationTopicModalHelper.load(`?id=${documentationId}&handler=AddOrUpdateDocumentationTopic`, undefined, () => {
                                if(self.addOrUpdateDocumentationTopicManager == undefined) {
                                    self.addOrUpdateDocumentationTopicManager = new AddOrUpdateDocumentationTopicManager(self.addOrUpdateDocumentationTopicModalHelper.getModalContainer());
                                }
                
                                self.addOrUpdateDocumentationTopicManager.initialize();
                            }, 
                            () => {
                                self.documentationGrid.refresh();
                            });
                        }
                    }
                }
            });

        self.documentationGrid.appendTo('#Grid');

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var addButton = toolbar.find('#add-button');
            addButton.off('click').on('click', () => {
                self.addOrUpdateDocumentationTopicModalHelper.load(`?handler=AddOrUpdateDocumentationTopic`, undefined, () => {
                    if(self.addOrUpdateDocumentationTopicManager == undefined) {
                        self.addOrUpdateDocumentationTopicManager = new AddOrUpdateDocumentationTopicManager(self.addOrUpdateDocumentationTopicModalHelper.getModalContainer());
                    }
    
                    self.addOrUpdateDocumentationTopicManager.initialize();
                }, 
                () => {
                    self.documentationGrid.refresh();
                });
            })

        }

        (<any>window).initializeAddOrUpdateDocumentationTopic = () => {
            self.addOrUpdateDocumentationTopicManager.initialize();
        }
    }

}